import { Tag, type TagProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { MarketDialogueStatus } from "../../autogen/bff-api";

export const MarketDialogueStatusTag = ({
  status,
  announced,
  ...tagProps
}: { status: MarketDialogueStatus; announced: boolean } & TagProps) => {
  const { t } = useTranslation();
  const { color, text } = ((): { color: string; text: string } => {
    switch (status) {
      case MarketDialogueStatus.Draft:
        return { color: "orange", text: t("Draft") };
      case MarketDialogueStatus.PublicationPending:
        return { color: "blue", text: t("Pending publication") };
      case MarketDialogueStatus.Published:
        return { color: "green", text: announced ? t("Published on Doffin") : t("Open to invited suppliers") };
      case MarketDialogueStatus.PublicationFailed:
        return { color: "red", text: t("Publication failed") };
      case MarketDialogueStatus.AnswerDeadlinePassed:
        return { color: "gray", text: t("Answer deadline passed") };
    }
  })();
  return (
    <Tag variant="outline" colorScheme={color} paddingTop="2px" paddingBottom="2px" {...tagProps}>
      {text}
    </Tag>
  );
};
